export const STORAGE_TOKEN_KEY = 'ia-succession-token';
